import { SortingFields } from './sortingFields';
import { SortingOrders } from './sortingOrders';

export const subscriptionPlansPaginationData = {
 page: 1,
 limit: 10,
 sortOrder: SortingOrders.ASC,
 sortField: SortingFields.numberOfSessions,
};
